import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';

import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';

import { StockLevelMonitoringTemplateInvLabelHdrLinkModel } from '../../../../../../models/aggregates/erp/stock/stock-level-monitoring-template-inv-label-hdr-link.model';


@Injectable({ providedIn: 'root' })
export class StockLevelMonitoringTemplateInvLabelHdrLinkService extends BaseApiTemplateService<StockLevelMonitoringTemplateInvLabelHdrLinkModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-template-inv-label-hdr-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-template-inv-label-hdr-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-template-inv-label-hdr-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = theHttp;
  }

}
